import React from 'react';
import { AlertTriangle, CheckCircle, Info, X } from 'lucide-react';
import BaseModal from './BaseModal';

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  type = 'danger', // 'danger', 'warning', 'info', 'success'
  confirmButtonClass = null
}) => {

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const getIcon = () => {
    switch (type) {
      case 'danger':
        return <AlertTriangle className="w-12 h-12 text-red-600 dark:text-red-400" />;
      case 'warning':
        return <AlertTriangle className="w-12 h-12 text-yellow-600 dark:text-yellow-400" />;
      case 'success':
        return <CheckCircle className="w-12 h-12 text-green-600 dark:text-green-400" />;
      case 'info':
      default:
        return <Info className="w-12 h-12 text-blue-600 dark:text-blue-400" />;
    }
  };

  const getDefaultButtonClass = () => {
    switch (type) {
      case 'danger':
        return 'bg-red-600 hover:bg-red-700 text-white';
      case 'warning':
        return 'bg-yellow-600 hover:bg-yellow-700 text-white';
      case 'success':
        return 'bg-green-600 hover:bg-green-700 text-white';
      case 'info':
      default:
        return 'bg-blue-600 hover:bg-blue-700 text-white';
    }
  };

  return (
    <BaseModal isOpen={isOpen} onClose={onClose} size="sm" showCloseButton={false}>
      {/* Header */}
      <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700 flex items-center justify-between">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
          {title}
        </h3>
        <button
          type="button"
          onClick={onClose}
          className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
          aria-label="Close modal"
        >
          <X className="w-5 h-5" />
        </button>
      </div>

      {/* Body */}
      <div className="px-6 py-6">
        <div className="flex flex-col items-center text-center">
          {getIcon()}
          <p className="mt-4 text-gray-700 dark:text-gray-300 whitespace-pre-line">
            {message}
          </p>
        </div>
      </div>

      {/* Footer */}
      <div className="px-6 py-4 border-t border-gray-200 dark:border-gray-700 flex flex-col-reverse sm:flex-row gap-3 sm:justify-end">
        <button
          type="button"
          onClick={onClose}
          className="w-full sm:w-auto px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
        >
          {cancelText}
        </button>
        <button
          type="button"
          onClick={handleConfirm}
          className={`w-full sm:w-auto px-4 py-2 rounded-md transition-colors ${
            confirmButtonClass || getDefaultButtonClass()
          }`}
        >
          {confirmText}
        </button>
      </div>
    </BaseModal>
  );
};

export default ConfirmModal;
